module.exports = __webpack_public_path__ + "img/zhaoshang_beijing@2x.6123388a.png";